module.exports = __webpack_public_path__ + "static/media/bonaldo.be2cd477.svg";